import { useQuery } from '@tanstack/react-query'
import { axiosGet } from 'Redux/axiosHelper'
import { FamilyFullResp } from 'types/family/family'
import { RequestParms } from 'types/globalTypes'

const getFamilyKids = async (familyId: string) => {
  const response = await axiosGet(`v1/families/${familyId}/kids`)
  return response.data
}

export const useGetFamilyKids = (familyId: string) => {
  const familyKids = useQuery<any>(
    ['kids-for-family'],
    () => getFamilyKids(familyId),
    { enabled: false },
  )
  return familyKids
}

//get all family members
const getFamilyMembers = async (familyId: string) => {
  const response = await axiosGet(`v1/families/${familyId}`)
  return response.data
}

export const useGetFamilyMembers = (familyId: string) => {
  const familyMemberList = useQuery<FamilyFullResp>(
    ['family-members-list'],
    () => getFamilyMembers(familyId),
    { enabled: false },
  )
  return familyMemberList
}

//get all family events
const getFamilyEvents = async (familyId: string, params: RequestParms) => {
  const response = await axiosGet(`v1/families/${familyId}/events`, params)
  return response.data
}
export const useGetFamilyEvents = (familyId: string, params: RequestParms) => {
  const familyEvents = useQuery<any>(
    ['family-events-list'],
    () => getFamilyEvents(familyId, params),
    { enabled: false },
  )
  return familyEvents
}
